import { useEffect } from 'react'
import { IMFO_MESSAGES_STORAGE_KEY } from './InfoMessages'

const SEEN_TAB_FLAG = '___imfo_tab_seen___'

const flushImportantMessages = () => {
    try {
        const raw = localStorage.getItem(IMFO_MESSAGES_STORAGE_KEY) || '[]'

        const messages: { id: string; important: boolean }[] = JSON.parse(raw)

        const priorityOnly = messages.filter(m => !m.important)
        localStorage.setItem(
            IMFO_MESSAGES_STORAGE_KEY,
            JSON.stringify(priorityOnly)
        )
    } catch (err) {
        console.error('Error filtering messages on tab close:', err)
    }
}

export const useFlushImportantMessagesWithSessionStorage = () => {
    useEffect(() => {
        const seenBefore = sessionStorage.getItem(SEEN_TAB_FLAG) === 'yes'

        if (!seenBefore) {
            flushImportantMessages()

            sessionStorage.setItem(SEEN_TAB_FLAG, 'yes')
        }
    }, [])
}
